module.exports = __webpack_public_path__ + "img/big5-2.e35e2ea8.jpg";